var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTourIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5229 22 22 17.5229 22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5229 6.47715 22 12 22Z",
    fill: "#1C1B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89136 2.75 2.75 6.89136 2.75 12C2.75 17.1086 6.89136 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89136 17.1086 2.75 12 2.75Z",
    fill: "#1C1B1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.5L8.5 17L12 14.5L15.5 17L12 6.5Z",
    fill: "#FFFBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 5.75C12.3229 5.75 12.6095 5.95657 12.7116 6.26283L16.2116 16.7628C16.3143 17.071 16.2069 17.4103 15.9456 17.6033C15.6843 17.7963 15.3285 17.7991 15.0641 17.6103L12.0001 15.4217L8.93598 17.6103C8.67163 17.7991 8.31578 17.7963 8.05447 17.6033C7.79316 17.4103 7.68581 17.071 7.78854 16.7628L11.2885 6.26283C11.3906 5.95657 11.6772 5.75 12.0001 5.75ZM9.94091 15.0491L11.5641 13.8897C11.8249 13.7034 12.1752 13.7034 12.436 13.8897L14.0592 15.0491L12.0001 8.87171L9.94091 15.0491Z",
    fill: "#FFFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIcon);
export default __webpack_public_path__ + "static/media/tourIcon.92d4956d742d39e3b779d1c110aa8a26.svg";
export { ForwardRef as ReactComponent };